var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { UIElement } from "./UIElement.js";
import "./Rectangle.js";
import "nanoid";
import "./utils.js";
import "lodash";
import "./UIService.js";
import "../global-33d5eebf.js";
import "../inputs/InputManager.js";
import "../utils/playSound.js";
import "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "pixi.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../persist/persist.js";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "../console/flags.js";
import "../console/editor.js";
import "../components/ComponentRegistry.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../enums-86f58524.js";
import "../components/types.js";
import "../utils/byteArray.js";
import "../console/floatingwindow.js";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
const defaultStyle = {
  position: "absolute",
  textAlign: "center",
  color: "white",
  backgroundColor: "transparent",
  border: "0px solid black",
  padding: "0",
  margin: "0",
  overflow: "visible"
};
class Box extends UIElement {
  constructor(bounds, config = {}) {
    super(bounds, { pointerEventsOnOverflow: true, ...config }, defaultStyle);
    __publicField(this, "_hasChanged", true);
  }
  onClickInternal(playerIndex) {
    var _a, _b;
    return (_b = (_a = this._config).onClick) == null ? void 0 : _b.call(_a, playerIndex);
  }
  onMouseDownInternal(playerIndex) {
    var _a, _b;
    return (_b = (_a = this._config).onMouseDown) == null ? void 0 : _b.call(_a, playerIndex);
  }
  onBlurInternal(playerIndex) {
    if (this._config.onBlur) {
      this._config.onBlur(playerIndex);
    }
  }
  onMouseUpInternal(playerIndex) {
    var _a, _b;
    return (_b = (_a = this._config).onMouseUp) == null ? void 0 : _b.call(_a, playerIndex);
  }
  onFocusInternal(playerIndex) {
    if (this._config.onFocus) {
      this._config.onFocus(playerIndex);
    }
  }
  onMouseEnterInternal(playerIndex) {
    if (this._config.onMouseEnter) {
      this._config.onMouseEnter(playerIndex);
    }
  }
  onMouseLeaveInternal(playerIndex) {
    if (this._config.onMouseLeave) {
      this._config.onMouseLeave(playerIndex);
    }
  }
  createElement() {
    const element = super.createElement();
    element.onscroll = (e) => {
      const fixedChildren = element.querySelectorAll(".breakout-overflow");
      for (const child of fixedChildren) {
        child.style.transform = `translate(${-element.scrollLeft}px, ${-element.scrollTop}px)`;
      }
    };
    if (this._config.breakoutOverflow) {
      element.classList.add("breakout-overflow");
    }
    return element;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
  updateInternal(gameModel) {
  }
  _update() {
    super._update();
    if (!this.isVisible()) {
      return;
    }
    if (this._config.pointerEventsOnOverflow && this._element) {
      setTimeout(() => {
        var _a;
        if (this._element) {
          if (this._element.scrollHeight > this._element.clientHeight) {
            this._element.style.pointerEvents = "auto";
          } else {
            this._element.style.pointerEvents = ((_a = this._config.style) == null ? void 0 : _a.pointerEvents) ?? "none";
          }
        }
      });
    }
    if (this._config.breakoutOverflow) {
      let scrolledParent = this.element.parentElement;
      while ((scrolledParent == null ? void 0 : scrolledParent.scrollLeft) === 0 && (scrolledParent == null ? void 0 : scrolledParent.scrollTop) === 0 || scrolledParent === document.body) {
        scrolledParent = scrolledParent.parentElement;
      }
      if (scrolledParent) {
        this.element.style.transform = `translate(${-scrolledParent.scrollLeft}px, ${-scrolledParent.scrollTop}px)`;
      }
    }
  }
}
export {
  Box
};
//# sourceMappingURL=Box.js.map
